import { render, staticRenderFns } from "./NotificationLiveChatInvitation.vue?vue&type=template&id=1feff15c&scoped=true&"
import script from "./NotificationLiveChatInvitation.vue?vue&type=script&lang=ts&"
export * from "./NotificationLiveChatInvitation.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationLiveChatInvitation.vue?vue&type=style&index=0&id=1feff15c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1feff15c",
  null
  
)

export default component.exports